import React from 'react'
import styled from 'styled-components'
import Container from 'components/elements/container'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'

const Section = styled.section`
  text-align: center;
  background: url('/img/investor-hero-unit.png');
  background-size: cover;
  @media (max-width: ${breakPoints.md.max}px) {
    padding: 64px 0;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    min-height: calc(100vh - 50px);
    display: flex;
    align-items: center;
  }
`

const SubHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  h4 {
    font-size: 2rem;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0 24px;
    color: #fff;
    font-weight: ${fontWeight.normal};
    letter-spacing: 8px;
  }
  .line {
    height: 2px;
    background: #fff;
    flex: 1;
    opacity: 0.5;
  }
  @media (max-width: ${breakPoints.md.max}px) {
    h4 {
      font-size: 1.25rem;
      padding: 0;
      text-align: center;
    }
    .line {
      display: none;
    }
  }
`

const Heading = styled.h1`
  font-size: 3rem;
  font-weight: ${fontWeight.medium};
  color: #ffffff;
  margin-top: 24px;
  margin-bottom: 0;
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 2rem;
  }
`

const HeroUnit = ({ data: { subHeading, heading } }) => {
  return (
    <Section>
      <Container>
        <SubHeading className='wow fadeIn'>
          <span className='line' />
          <h4>{subHeading}</h4>
          <span className='line' />
        </SubHeading>
        <Heading className='wow fadeIn'>{heading}</Heading>
      </Container>
    </Section>
  )
}

export default HeroUnit
